<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="100px">
                        <div>
                            <el-form-item label="所属部门">
                                <selectTree style="width: 180px" v-model="tree_model" :rowKeys="treekeys" :tree-data="treeData" :isMulti="false"
                                            placeholder="请选择顶级部门"></selectTree>
                            </el-form-item>
                            <el-form-item label="项目名称">
                                <el-input style="width: 180px" v-model="projectName" placeholder="双击选择项目名称"  @click.native="selProject">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="业务员">
                                <el-input style="width: 180px" v-model="salesMan" placeholder="双击选择业务员" @click.native="selStaff">
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-search" type="primary" size="medium" @click="search">
                                    查询
                                </el-button>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="客户">
                                <el-input style="width: 180px" v-model="customerName" placeholder="输入或双击选择客户" @click.native="selCustomer">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="成本单价">
                                <el-select v-model="costPrice" placeholder="请选择成本单价" style="width: 180px">
                                    <el-option label="库存价" value="1"></el-option>
                                    <el-option label="成本价1" value="2"></el-option>
                                    <el-option label="成本价2" value="3"></el-option>
                                    <el-option label="成本价3" value="4"></el-option>
                                    <el-option label="成本价4" value="5"></el-option>
                                    <el-option label="成本价5" value="6"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="账单日期">
                                <el-date-picker
                                        v-model="billDate"
                                        size="medium"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="仓号">
                                <el-input style="width: 180px" v-model="warehouseNo" placeholder="双击选择仓库" @click.native="selWareHouse">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="物资编码">
                                <el-input style="width: 180px" v-model="proCode" placeholder="双击选择物资编码" >
                                    <el-button slot="append" icon="el-icon-plus" style="padding: 10px"
                                               @click="selProduct(1)"></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="物资名称">
                                <el-input style="width: 180px" v-model="proName" placeholder="双击选择物资名称" >
                                    <el-button slot="append" icon="el-icon-plus" style="padding: 10px"
                                               @click="selProduct(2)"></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-download" type="primary" size="medium" @click="excel">
                                    导出
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>

        <selStaff v-if="showStaff"
                  :staffId="staffId"
                  @closeDialog="closeDialog"
                  @checkRow="checkStaff">
        </selStaff>
        <selCustomer v-if="showCustomer"
                     :customerId="customerId"
                     @closeDialog="closeDialog"
                     @checkRow="checkCustomer">
        </selCustomer>
        <selProject v-if="showProject"
                    :projectId="projectId"
                    @closeDialog="closeDialog"
                    @checkRow="checkProject">
        </selProject>
        <selWareHouse v-if="showWareHouse"
                      :warehouseId="warehouseId"
                      @closeDialog="closeDialog"
                      @checkRow="checkWareHouse">
        </selWareHouse>
        <selProduct v-if="showProduct"
                      :productInfoId="productInfoId"
                      @closeDialog="closeDialog"
                      @checkRow="checkProduct">
        </selProduct>
    </div>
</template>

<script>
    import selWareHouse from '@/components/page/stock/warehouse/selWareHouse'
    import selCustomer from '@/components/page/customer/customer/selCustomer'
    import selProject from '@/components/page/project/selProject'
    import selStaff from '@/components/rszy/staff/selStaff'
    import selectTree from '@/components/tools/tree/selectTree'
    import selProduct from '@/components/page/wzgl/wzgl/selWzSingle'

    export default {
        name: 'toolBar',
        props: ['menuId', 'toolHeight', 'loading'],
        components: {
            selStaff,selCustomer,selProject,selectTree,selWareHouse,selProduct
        },
        data() {
            return {
                warehouseId:"",
                warehouseNo:"",
                showWareHouse:false,
                tree_model: {
                },
                treeData: [],
                treekeys: {
                    id: 'id',
                    name: 'name',
                    parent: 'parentId',
                    children: 'children'
                },
                departmentName:"",
                searBarHeight: 70,
                costPrice:"",
                makeBy:"",
                showStaff:false,
                showCustomer:false,
                showProject:false,
                showProduct:false,

                billNo:"",
                staffId:"",
                salesMan:"",
                billDate:[],
                projectId:"",
                projectName:"",
                reviewState:"",
                customerId:"",
                customerName:"",
                productInfoId:"",
                productKind:1,
                proCode:"",
                proName:"",
            }
        },

        mounted(){
            this.getDepartmentTree();
        },
        methods: {
            async getDepartmentTree() {
                this.dialoading = true;
                let param = {
                    url:"/department/listTopZTree",
                    param:{}
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    const retData = data.data.jsonStr;
                    if(retData){
                        this.treeData = retData;
                    }
                }
                this.dialoading = false;
            },
            closeDialog() {
                this.showCustomer =false;
                this.showProject = false;
                this.showStaff = false;
                this.showWareHouse = false;
                this.showProduct = false;
            },
            selProduct(kind){
                this.productKind=kind;
                this.showProduct = true;
            },
            checkProduct(row) {
                this.productInfoId = row.productInfoId;
                if(this.productKind===1) {
                    this.proCode = row.proCode;
                }else {
                    this.proName = row.proName;
                }
                this.showProduct = false;
            },
            selWareHouse(){
                this.showWareHouse = true;
            },
            checkWareHouse(row) {
                this.warehouseId = row.warehouseId;
                this.warehouseNo = row.warehouseNo;
                this.showWareHouse = false;
            },
            selStaff() {
                this.showStaff = true;
            },
            checkStaff(row) {
                this.staffId = row.staffId;
                this.salesMan = row.staffName;
                this.showStaff = false;
            },
            selCustomer(){
                this.showCustomer = true;
            },
            checkCustomer(row) {
                this.customerId = row.customerId;
                this.customerName = row.customerName;
                this.showCustomer = false;
            },
            selProject() {
                this.showProject = true;
            },
            checkProject(row) {
                this.projectId = row.projectId;
                this.projectName = row.projectName;
                this.showProject = false;
            },
            search() {

                let startDate = "";
                let endDate = "";
                if(this.billDate && this.billDate.length>0){
                    startDate = this.billDate[0];
                    endDate = this.billDate[1];
                }
                let searchData = {
                    startDate:startDate,
                    endDate:endDate,
                    billNo:this.billNo,
                    projectName:this.projectName,
                    costPrice:this.costPrice,
                    departmentName:this.departmentName,
                    makeBy:this.makeBy,
                    salesMan:this.salesMan,
                    customerName:this.customerName,
                    warehouseNo:this.warehouseNo,
                    proCode:this.proCode,
                    proName:this.proName,
                }
                this.$emit('search',searchData);
            },
            excel() {
                let startDate = "";
                let endDate = "";
                if(this.billDate && this.billDate.length>0){
                    startDate = this.billDate[0];
                    endDate = this.billDate[1];
                }
                let searchData = {
                    startDate:startDate,
                    endDate:endDate,
                    billNo:this.billNo,
                    projectName:this.projectName,
                    costPrice:this.costPrice,
                    departmentName:this.departmentName,
                    makeBy:this.makeBy,
                    salesMan:this.salesMan,
                    customerName:this.customerName,
                    warehouseNo:this.warehouseNo,
                    proCode:this.proCode,
                    proName:this.proName,
                }
                this.$emit('excel',searchData);
            },
        }
    }
</script>

